import { Routes } from '@angular/router';
import { RoleGuard } from '@guards/role.guard';

const distributorModule = () => import('./distributor.module').then((m) => m.DistributorModule);

export const distributorRoutes: Routes = [
  {
    path: 'distributor',
    canActivateChild: [RoleGuard],
    loadChildren: distributorModule,
    data: {
      enum: 'DISTRIBUTOR',
      label: 'Distributor',
      icon: 'ic_distributor.svg',
      activeClass: 'active',
      children: [
        {
          enum: 'LIST_TEREGISTRASI',
          label: 'Teregistrasi',
          path: 'distributor/teregistrasi/active',
          children: [],
        },
        {
          enum: 'LIST_MENUNGGU',
          label: 'Sedang Menunggu',
          path: 'distributor/pending/registration',
          children: [],
        },
        {
          enum: 'LIST_DITOLAK',
          label: 'Ditolak',
          path: 'distributor/reject/registration',
          children: [],
        },
      ],
    },
  },
];
